import React, { useState } from 'react';
import { ui } from './toolTheme';
const API_BASE = process.env.REACT_APP_API_BASE || '';

const EmailRewritePage = ({ setPage }) => {
  const [text, setText] = useState('');
  const [tone, setTone] = useState('professional');
  const [output, setOutput] = useState('');
  const [err, setErr] = useState('');

  const run = async () => {
    setErr(''); setOutput('');
    try {
      const res = await fetch(`${API_BASE}/api/email/rewrite`, {
        method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ text, tone }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed');
      setOutput(data.result || '');
    } catch (e) { setErr(e.message || 'Failed'); }
  };

  return <main style={ui.page}><div style={{...ui.container, maxWidth:860}}>
    <button onClick={()=>setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>
    <div style={ui.card}><h1 style={ui.sectionTitle}>AI Email Rewrite</h1></div>
    <div style={{...ui.card, marginTop:14}}>
      <textarea value={text} onChange={(e)=>setText(e.target.value)} rows={9} placeholder='Paste email text' style={ui.textarea} />
      <div style={{display:'flex', gap:10, marginTop:8}}>
      <select value={tone} onChange={(e)=>setTone(e.target.value)} style={{...ui.select, maxWidth:220}}><option>professional</option><option>friendly</option><option>concise</option></select>
      <button onClick={run} style={ui.primaryBtn}>Rewrite</button>
      </div>
      {err && <div style={ui.error}>{err}</div>}
      <textarea value={output} readOnly rows={9} style={{...ui.textarea, marginTop:10}} />
    </div>
  </div></main>;
};

export default EmailRewritePage;
